import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { PolicyOrAccount } from "../../../interfaces/DTO/mislaka_xml_models";
import { formatPayerIdType, formatPaymentMethod, formatIndexationMethod, formatPaymentFrequency } from "../../../utils/enumFormatter";

export interface DepositCollectionDetailsSummaryProps {
  policies: PolicyOrAccount[];
}

export const DepositCollectionDetailsSummary: React.FC<DepositCollectionDetailsSummaryProps> = ({ policies }) => {
    return (
      <Box>
        {policies.flatMap((policy, policyIndex) =>
         (policy.deposit_collection_details ?? []).map((detail, detailIndex) => (
            <Box key={`${policyIndex}-${detailIndex}`} mb={2}>
              <Typography><strong>שם משלם:</strong> {detail.payer_name}</Typography>
              <Typography><strong>סוג מזהה משלם:</strong> {formatPayerIdType(detail.payer_id_type)}</Typography>
              <Typography><strong>מספר מזהה משלם:</strong> {detail.payer_id_number}</Typography>
              <Typography><strong>אמצעי תשלום:</strong> {formatPaymentMethod(detail.payment_method)}</Typography>
              <Typography><strong>תדירות תשלום:</strong> {formatPaymentFrequency(detail.payment_frequency)}</Typography>
              <Typography><strong>חודש ייחוס:</strong> {detail.reference_month}</Typography>
              <Typography><strong>יום גביה בחודש:</strong> {detail.payment_day_in_month}</Typography>
              <Typography><strong>אופן הצמדה:</strong> {formatIndexationMethod(detail.indexation_method)}</Typography>
              <Typography><strong>אחוז תת שנתיות:</strong> {detail.sub_yearly_percentage}</Typography>
  
              <Divider sx={{ my: 2 }} />
            </Box>
          ))
        )}
      </Box>
    );
  };